export const BuilderState = {
	url: '/equipment/:consultationId?debug',
	title: 'Equipment',
	template: '<equipment-page></equipment-page>',
	params: {consultationId: null, mock: null},
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "equipmentPageMod" */
			'@Containers/builder-equipment-page/equipment-page.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
	resolve: [
		{
			token: 'canView',
			policy: {when: 'EAGER'},
			deps: ['RoutesResolveSvc', '$transition$'],
			resolveFn: (RoutesSvc, trans) =>
				RoutesSvc.validateConsultationPrivate({status: 'draft', ...trans.params()}).catch(state =>
					trans.router.stateService.go(state.name, state.params)
				),
		},
	],
};

export const BuilderInspectorState = {
	url: '/inspector/:consultationId/:proposalId',
	title: 'Proposal Inspector',
	template: '<equipment-inspector-page></equipment-inspector-page>',
	params: {consultationId: null, proposalId: null},
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "equipmentInspectorPageMod" */
			'@Containers/builder-equipment-page/equipment-inspector-page.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
